export const FEATURE_FLAG_SCAN_SPACE_UI = {
  key: 'feature-flag-scan-space-ui',
  defaultValue: true,
  devOnly: false,
  name: 'ScanSpaceUI',
  description: 'Show the Administration tab for configuring scan spaces.',
} as const;
export const FEATURE_FLAG_WELCOME_WIZARD = {
  key: 'feature-flag-welcome-wizard',
  defaultValue: true,
  devOnly: true,
  name: 'WelcomeWizard',
  description: 'Controls whether the welcome wizard shows if no agents are configured.',
} as const;
export const FEATURE_FLAG_RELATIONSHIP_DETAIL = {
  key: 'feature-flag-relationship-detail',
  defaultValue: false,
  devOnly: false,
  name: 'RelationshipDetails',
  description: 'Controls the availability of the relationship details context menu.',
} as const;
